// src/services/presensiService.js
import axios from "axios";
import { ApiConfig } from "../constants/apiConfig";

const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    const localHosts = ["localhost", "127.0.0.1"];
    if (!window.isSecureContext && !localHosts.includes(window.location.hostname)) {
      return reject("Presensi memerlukan koneksi HTTPS agar lokasi iPhone dapat digunakan.");
    }

    if (!navigator.geolocation) {
      return reject("Geolocation tidak didukung");
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude.toString(),
          longitude: position.coords.longitude.toString(),
        });
      },
      (error) => {
        reject(`Gagal mendapatkan lokasi: ${error.message}`);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
};

export const kirimPresensiHadir = async () => {
  try {
    const siswaId = localStorage.getItem("user_id");
    const guruId = localStorage.getItem("guru_pembimbing_id");
    const tempatPklId = localStorage.getItem("tempat_pkl_id");

    if (!siswaId || !guruId || !tempatPklId) {
      return {
        success: false,
        message: "Data pengguna tidak lengkap di localStorage",
      };
    }

    const location = await getCurrentLocation();

    const now = new Date();
    const jam = now.toTimeString().split(" ")[0]; // "HH:MM:SS"

    const response = await axios.post(
      `${ApiConfig.baseUrl}/absensi`,
      {
        siswa_id: siswaId,
        guru_pembimbing_id: guruId,
        tempat_pkl_id: tempatPklId,
        latitude: location.latitude,
        longitude: location.longitude,
        jam: jam,
        status: "hadir",
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("student_token") || ""}`,
          Accept: "application/json",
        },
      }
    );

    // Jika response berhasil (200 atau 201)
    if (response.status === 200 || response.status === 201) {
      const data = response.data;
      return {
        success: true,
        message: data.message || "Presensi berhasil dikirim",
        data: data.data || null,
      };
    }

    // Jika bukan status sukses, fallback ke error
    return {
      success: false,
      message: response.data?.message || "Gagal melakukan presensi",
      action: response.data?.action,
    };
  } catch (error) {
    // Jika error dari axios yang punya response (error validasi 400, 422, dll)
    if (error.response) {
      const data = error.response.data;
      if (data && data.message) {
        // Jika message berupa objek (validator errors)
        if (typeof data.message === "object") {
          let errors = [];
          for (const key in data.message) {
            if (data.message.hasOwnProperty(key)) {
              errors = errors.concat(data.message[key]);
            }
          }
          return {
            success: false,
            message: errors.join(", "),
            action: data.action,
          };
        }

        // Jika message berupa string
        return {
          success: false,
          message: data.message,
          action: data.action,
        };
      }

      // Jika tidak ada pesan error yang jelas
      return {
        success: false,
        message: "Gagal melakukan presensi (tidak ada pesan error detail)",
        action: data.action,
      };
    }

    // Jika error jaringan atau error lain
    return {
      success: false,
      message: `Terjadi kesalahan: ${error.message || error.toString()}`,
    };
  }
};
